import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { LocalizationService } from '@imagise/shared';

@Component({
  selector: 'app-main-container-page',
  imports: [RouterOutlet],
  templateUrl: './main-container-page.component.html',
  styleUrl: './main-container-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainContainerPageComponent implements OnInit {
  #activatedRoute = inject(ActivatedRoute);
  #localizationService = inject(LocalizationService);

  ngOnInit() {
    this.#localizationService.initialize(this.#activatedRoute.snapshot.params['lang'] || 'en');
  }
}
